import { Component, OnInit } from '@angular/core';
import { TokenStorage } from 'src/app/token.storage';

@Component({
  selector: 'app-aboutus',
  templateUrl: './aboutus.component.html',
  styleUrls: ['./aboutus.component.css']
})
export class AboutusComponent implements OnInit {
  slideImage = [
    {
      imageUrl: 'assets/images/Kalinga 1a.JPG',
      title: '',
    },
    {
      imageUrl: 'assets/images/Kalinga 3a.JPG',
      title:'',
    },
    {
      imageUrl: 'assets/images/Kalinga 4a.JPG',
      title:'',
    }
  ];
  slideConfig = {
    dots: true,
    dotsData: true,
    centerMode: true,
    centerPadding: '0',
    slidesToShow: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    arrows: true,

    responsive: [
      {
        breakpoint: 1367,
        settings: {
          centerPadding: '0',
          dots: false
        },
      },
      {
        breakpoint: 1025,
        settings: {
          centerPadding: '0',
          slidesToShow: 1,
        },
      },
      {
        breakpoint: 767,
        settings: {
          centerPadding: '0',
          slidesToShow: 1,
        },
      },
    ],
  };
  constructor(
    public token: TokenStorage,
  ) { }

  ngOnInit(): void {
  }

}
